import {
  Component,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ElementRef,
  SimpleChanges,
  OnChanges,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'div[sg-flex-divider]',
  templateUrl: './flex-divider.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgFlexDividerComponent implements OnInit, OnChanges {
  /**
   * Width, in px.
   * The width of the divider
   */
  @Input() width: number | undefined = 1;
  /**
   * Padding, in px.
   * Applied on left and right.
   */
  @Input() padding: number | undefined = 32;
  /**
   * Height of the divider, in % relative to parent.
   */
  @Input() height: number | undefined = 90;

  /**
   * The color of the divider.
   * Any valid css color.
   */
  @Input() color: string = 'rgba(0, 0, 0, 0.12)';

  private el: HTMLElement;
  style: any;

  constructor(private elRef: ElementRef) {
    this.el = elRef.nativeElement;
    this.el.style.display = 'flex';
    this.el.style.alignItems = 'center';
    this.el.style.boxSizing = 'border-box';
    this.el.style.alignSelf = 'stretch';
  }

  ngOnInit(): void {
    this.update();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  private update(): void {
    const el = this.el;

    const width = this.width >= 0 ? `${this.width}px` : undefined;
    const padding = this.padding >= 0 ? `${this.padding}px` : undefined;
    const height = this.height >= 0 ? `${this.height}%` : undefined;

    el.style.flex = width ? `0 0 ${width}` : width;
    el.style.maxWidth = el.style.minWidth = width;
    el.style.padding = padding ? `0 ${padding}` : padding;

    this.style = {
      height,
      minWidth: width,
      maxWidth: width,
      background: this.color,
    };
  }
}
